<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
		<path d="M5.54548 8.25L14.1673 8.25L14.1673 9.75L5.54548 9.75L9.34498 13.773L8.3434 14.8335L2.83398 9L8.3434 3.1665L9.34498 4.227L5.54548 8.25Z" fill="white"/>
	</svg>
</template>
